import React, { ChangeEvent, FocusEvent, MouseEvent } from 'react'
import { IIshikawaCategory, IIshikawaDiagram } from '../types'
import { CauseContent, CausesGroup, CauseTopDiagonalDot, CauseTopDiagonalLine, CauseTopItem, ContentCauseRoot } from '../style'
import GetCategory from './GetCategory'
import { GetRootCauses } from './GetRootCause'

interface IGetTopCausesContent {
  diagram: IIshikawaDiagram
  handleDoubleClick: (event: MouseEvent<HTMLSpanElement>, category: IIshikawaCategory) => void
  handleBlur: (e: FocusEvent<HTMLInputElement>, category: IIshikawaCategory) => void
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void
  handleClickCause: (
      event: MouseEvent<HTMLSpanElement>,
      category: IIshikawaCategory,
      causeIndex: number,
      value: string
  ) => void
}
export default function GetTopCausesContent({diagram,handleChange,handleClickCause,handleBlur,handleDoubleClick}: IGetTopCausesContent) {
    const categories =
        diagram && diagram.categories
            ? diagram.categories.map(
                  (category: IIshikawaCategory) => category.title
              )
            : []
    const topCauses: JSX.Element[] = categories
        .slice(0, categories.length / 2)
        .map((category: string, index: number) => {
            let objCategory =
                diagram &&
                diagram.categories
                    .filter((cat: IIshikawaCategory) => cat.title === category)
                    .find((c: IIshikawaCategory) => !!c)
            return (
                <CauseContent
                    data-testid="test-top-cause-group"
                    key={`top_causes_${category}_${index}`}>
                    <CauseTopItem>
                        <GetCategory
                            index={index}
                            category={objCategory}
                            handleBlur={handleBlur}
                            handleChange={handleChange}
                            handleDoubleClick={handleDoubleClick}
                        />
                    </CauseTopItem>
                    <ContentCauseRoot>
                        <GetRootCauses
                            diagram={diagram}
                            category={category}
                            handleChange={handleChange}
                            handleClickCause={handleClickCause}
                        />
                        <CauseTopDiagonalLine>
                            <CauseTopDiagonalDot />
                        </CauseTopDiagonalLine>
                    </ContentCauseRoot>
                </CauseContent>
            )
        })

    return <CausesGroup>{topCauses}</CausesGroup>
}
